import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Posts the client-side PCRS result to the BE so eligibility becomes
// server-authoritative, then refetches the CDM status so allowed/denied actions
// reflect PCRS. Mirrors useSendCDM conventions. The payload carries the scheme
// check (parsed `result` + `rawXml`) and, when available, the cdm-ws patient
// details (`patientDetailsResult` + `patientDetailsRawXml`) — the caller
// assembles it, so the mutation posts it verbatim.
export const useSavePcrsSchemeCheck = ({ patientId }) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    // The caller decides whether to surface failures; a failed audit-post must
    // not block the CDM page, so suppress the global error toast.
    meta: { skipGlobalError: true },
    mutationFn: async (payload) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/cdm/patients/${patientId}/pcrs-scheme-check`,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      // BE now factors the scheme check into allowed/denied actions.
      queryClient.invalidateQueries({
        queryKey: ["patientCDMStatus", patientId],
      });
    },
  });
};
